module.exports = __webpack_public_path__ + "img/neogeo_logo.867f6752.png";